var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 2c1.103 0 2 .897 2 2v16c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2V4c0-1.103.897-2 2-2h20zM7.947 10.362L2 15.458V20h19.997l-.001-1.642-4.156-4.988-3.24 2.43a1 1 0 01-1.307-.093l-5.345-5.345zM22 4H2v8.825l5.35-4.584a1 1 0 011.357.052l5.386 5.387L17.4 11.2a1.001 1.001 0 011.37.16l3.228 3.874L22 4zm-5.498 2a1.501 1.501 0 010 3A1.502 1.502 0 0115 7.5c0-.827.674-1.5 1.502-1.5z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconImage;